// فئة إدارة الأمان والمصادقة
class AuthSecurity {
  constructor() {
    this.lastActivity = Date.now();
  }

  // تشفير البيانات الحساسة
  encryptData(data) {
    try {
      // استخدام Base64 للتشفير البسيط (يمكن تحسينه لاحقاً)
      return btoa(JSON.stringify(data));
    } catch (error) {
      console.error('خطأ في تشفير البيانات:', error);
      return null;
    }
  }

  // فك تشفير البيانات
  decryptData(encryptedData) {
    try {
      return JSON.parse(atob(encryptedData));
    } catch (error) {
      console.error('خطأ في فك تشفير البيانات:', error);
      return null;
    }
  }

  // حفظ بيانات المستخدم بشكل آمن
  setSecureUserData(key, data) {
    try {
      const encryptedData = this.encryptData(data);
      if (encryptedData) {
        localStorage.setItem(`secure_${key}`, encryptedData);
        // إضافة timestamp للتحقق من صحة البيانات
        localStorage.setItem(`secure_${key}_timestamp`, Date.now().toString());
      }
    } catch (error) {
      console.error('خطأ في حفظ البيانات الآمنة:', error);
    }
  }

  // استرجاع بيانات المستخدم الآمنة
  getSecureUserData(key, maxAge = 24 * 60 * 60 * 1000) { // 24 ساعة افتراضياً
    try {
      const encryptedData = localStorage.getItem(`secure_${key}`);
      const timestamp = localStorage.getItem(`secure_${key}_timestamp`);
      
      if (!encryptedData || !timestamp) {
        return null;
      }

      // فحص عمر البيانات
      const age = Date.now() - parseInt(timestamp);
      if (age > maxAge) {
        this.removeSecureUserData(key);
        return null;
      }

      return this.decryptData(encryptedData);
    } catch (error) {
      console.error('خطأ في استرجاع البيانات الآمنة:', error);
      return null;
    }
  }

  // إزالة بيانات المستخدم الآمنة
  removeSecureUserData(key) {
    localStorage.removeItem(`secure_${key}`);
    localStorage.removeItem(`secure_${key}_timestamp`);
  }

  // تسجيل الخروج الآمن
  async logout() {
    try {

      
      // مسح جميع البيانات المحلية
      this.clearAllSecureData();
      
      // مسح البيانات التقليدية
      localStorage.removeItem('userType');
      localStorage.removeItem('userId');
      

      
      return true;
    } catch (error) {
      console.error('خطأ في تسجيل الخروج:', error);
      throw error;
    }
  }

  // مسح جميع البيانات الآمنة
  clearAllSecureData() {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith('secure_')) {
        localStorage.removeItem(key);
      }
    });
  }

  // التحقق من صحة الجلسة
  isValidSession() {
    const userData = this.getSecureUserData('user');
    const userType = localStorage.getItem('userType');
    
    return userData && userType;
  }

  // تحديث نشاط المستخدم
  updateActivity() {
    this.lastActivity = Date.now();
  }

  // الحصول على معلومات الجلسة
  getSessionInfo() {
    return {
      lastActivity: this.lastActivity,
      timeRemaining: this.sessionTimeout - (Date.now() - this.lastActivity),
      isValid: this.isValidSession()
    };
  }

  // تجديد الجلسة
  refreshSession() {
    this.lastActivity = Date.now();
    // يمكن إضافة منطق إضافي لتجديد التوكن هنا
  }

  // فحص قوة كلمة المرور
  validatePasswordStrength(password) {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    
    const score = [
      password.length >= minLength,
      hasUpperCase,
      hasLowerCase,
      hasNumbers,
      hasSpecialChar
    ].filter(Boolean).length;
    
    return {
      score,
      isStrong: score >= 4,
      suggestions: [
        password.length < minLength ? 'يجب أن تكون كلمة المرور 8 أحرف على الأقل' : null,
        !hasUpperCase ? 'أضف حرف كبير واحد على الأقل' : null,
        !hasLowerCase ? 'أضف حرف صغير واحد على الأقل' : null,
        !hasNumbers ? 'أضف رقم واحد على الأقل' : null,
        !hasSpecialChar ? 'أضف رمز خاص واحد على الأقل' : null
      ].filter(Boolean)
    };
  }
}

// إنشاء مثيل واحد للاستخدام في التطبيق
const authSecurity = new AuthSecurity();

export default authSecurity;

// تصدير دوال مساعدة
export const {
  setSecureUserData,
  getSecureUserData,
  removeSecureUserData,
  logout,
  isValidSession,
  updateActivity,
  getSessionInfo,
  refreshSession,
  validatePasswordStrength
} = authSecurity;